/**
 * 路由配置
 */
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import treeEach from 'operation-tree-node/dist/treeEach.js';
// 主容器组件
import Layout from '../layout';

//首页路由
import Dashboard from 'iebdc/views/new-dashboard';

// 个人注册组件
import SignIn from '../views/sign-in';

// 新增 个人注册组件 前置步骤
import PreSignIn from '../views/pre-sign-in';

// 新增 个人注册组件 前置步骤
import ChangePassword from '../views/change-password';

// 主区子路由
// import dashboardRoute from './modules/dashboard'; // 主界面
// import dashboardRoute from './modules/new-dashboard';
import policyLawRoute from './modules/policy-law'; // 政策法规
import guidanceRoute from './modules/guidance'; // 办事指南
import fileDownloadRoute from './modules/file-download'; // 资料下载
import messageRoute from './modules/message'; // 留言板
import PublicAnnouncementRoute from './modules/public-announcement'; // 公示公告
import userCenter from './modules/user-center'; // 个人中心
import exampleRoute from './modules/example';
// import apply from './modules/apply'; // 我要申请
import myApplicationRoute from './modules/my-application'; // 我的申请
// import serviceAppointment from './modules/service-appointment'; // 我要预约
import myAppointmentRoute from './modules/my-appointment'; // 我的预约
// import visitionService from './modules/visiting-service'; // 上门服务
// import myVisitRoute from './modules/my-visit'; // 我的上门
// import progressQuery from './modules/progress-query'; // 进度查询
// import certificateVerification from './modules/certificate-verification'; // 证书核实
// import quanSZMQuery from './modules/quanSZM-query'; // 权属证明查询
import myQueryRoute from './modules/my-query'; // 我的查询
import express from './modules/express'; // 我的邮寄
import aboutRoute from './modules/about'; // 关于我们
import statementRoute from './modules/statement'; // 本站声明
import newmanGuideRoute from './modules/newman-guide'; // 新手向导
import connectRoute from './modules/connect'; // 联系我们
// import electronicLicenseRoute from './modules/electronic-license'; //电子证照
import onlinePay from './modules/online-pay'; //在线缴费
// import gpyTest from './modules/gpy-test'; //gpyTest
import checkInRoute from './modules/check-in'; // 登记办理
import checkIn1Route from './modules/check-in1'; // 登记办理
import infoSearchRoute from './modules/info-search'; // 信息查询办理
import appointmentRoute from './modules/appointment'; // 网上预约
import bswd from './modules/bswd'; //办事网点
import xxfw from './modules/xxfw'; //信息服务
import { localDataUser, localDataPermission } from '@iebdc/utils/local-data';
import { routerPermission } from '@iebdc/utils/utils';
import unifiedService from '@iebdc/api/unified-service.js';
import { checkTokenHandle, sxblcheckTokenHandle, fcxxcheckTokenHandle } from './login-hn';
import { crypto } from '@iebdc/utils/crypto';
// 子模块的路由注册
export const subRoutes = [
  // dashboardRoute, //首页
  checkInRoute, //登记办理
  checkIn1Route,
  infoSearchRoute, //信息查询
  appointmentRoute, //网上预约
  onlinePay, //在线缴费
  bswd, //办事网点
  messageRoute, //留言板
  xxfw, //信息服务
  //guidanceRoute, // 办事指南
  //policyLawRoute, //政策法规
  //fileDownloadRoute, //资料下载
  //PublicAnnouncementRoute, //公示公告
  userCenter, //用户中心
  // exampleRoute,
  //申请
  // apply,
  myApplicationRoute,
  //预约
  // serviceAppointment,
  myAppointmentRoute,
  // visitionService,
  // myVisitRoute,
  //查询
  // progressQuery,
  // certificateVerification,
  // quanSZMQuery,
  myQueryRoute,
  // express,
  // onlinePay,
  // electronicLicenseRoute,
  aboutRoute, // 关于我们
  statementRoute, // 声明
  newmanGuideRoute, //新手指南
  connectRoute, // 联系我们
];
Vue.use(Router);

/**
 * 增加子模块的激活菜单元数据，
 * example: { meta: { activePath: parentPath } }
 * 这个数据会在 layout/Navbar.vue 中进行导航的激活状态判断
 */
treeEach(subRoutes, (item, index, arr, parent) => {
  parent && (item.meta.activePath = parent.meta.activePath || parent.path);
});

//宁夏统一登录
const login = (Authorization, next) => {
  const UNIFIED_AUTHORIZATION = Authorization;
  $.ajax({
    type: 'POST',
    url: `${crypto.decryptByDES(window.CONFIG.UNIFIED_ACCESSTOKEN)}?client_id=${
      window.CONFIG.UNIFIED_CLIENT_ID
    }&client_secret=${
      window.CONFIG.UNIFIED_CLIENT_KEY
    }&code=${Authorization}&scope=all&grant_type=authorization_code&redirect_uri=${crypto.decryptByDES(
      window.CONFIG.UNIFIED_PAGE
    )}`,
    success: function (res) {
      if (res.access_token) {
        localDataUser.set({
          access_token: res.access_token,
          UNIFIED_AUTHORIZATION: UNIFIED_AUTHORIZATION,
        });
        checkTokenHandle(res.access_token, next);
      }
    },
    error: (res) => {
      Vue.prototype.$message.error('登录失败！');
      next();
    },
  });
  return;
  // window.location.href = `${window.CONFIG.UNIFIED_ACCESSTOKEN}?client_id=${window.CONFIG.UNIFIED_CLIENT_ID}&client_secret=${window.CONFIG.UNIFIED_CLIENT_KEY}&code=${Authorization}&scope=all&grant_type=authorization_code&redirect_uri=${window.CONFIG.UNIFIED_PAGE}`
  unifiedService
    .getAccessToken({
      // authorization: Authorization,
      // ssoLoginUrl: window.CONFIG.login + 'login',
      // appKey: window.CONFIG.APP_IEBDC_KEY
      client_id: window.CONFIG.UNIFIED_CLIENT_ID,
      client_secret: window.CONFIG.UNIFIED_CLIENT_KEY,
      code: Authorization,
      scope: 'all',
      grant_type: 'authorization_code',
      redirect_uri: window.CONFIG.UNIFIED_PAGE,
    })
    .then((res) => {
      console.log(res, 'res');
      if (res.success) {
        localDataUser.set({
          token: res.data.gmsso_cli_ec_key,
          UNIFIED_AUTHORIZATION: UNIFIED_AUTHORIZATION,
        });
        checkTokenHandle(res.data.gmsso_cli_ec_key, next);
      }
    })
    .catch((error) => {
      console.log(error, 'error');
      if (error.message === '未实名认证！') {
        window.location.href = window.CONFIG.UNIFIED_HOME;
      } else {
        Vue.prototype.$message.error(error.message);
        next('/');
      }
    });
};

// 路由集合
const routes = [
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('../views/change-password'),
  },
  {
    path: '/pre-sign-in',
    name: 'pre-sign-in',
    component: () => import('../views/pre-sign-in'),
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import('../views/sign-in'),
  },
  {
    path: '/',
    name: 'home-login-out',
    component: () => import('iebdc/views/new-dashboard'),
    beforeEnter: async (to, from, next) => {
      console.log('=======1222====', window.location.href.indexOf('fccx'));
      if (window.location.search.indexOf('ywh0') > -1) {
        let ywh = window.top.location.search.substr(1).match(/(^|&)ywh0=([^&]*)(&|$)/)[2];
        var url = window.location.href; //获取当前页面的url
        //判断是否存在参数
        url = url.replace(/(\?|#)[^'"]*/, ''); //去除参数
        window.history.pushState({}, 0, url);
        next({ name: 'user-center', params: { ywh: ywh } });
      } else if (window.location.search.indexOf('code') > -1) {
        let Authorization = window.location.search.replace('?code=', '');
        let url = window.location.href; //获取当前页面的url
        //判断是否存在参数
        url = url.replace(/(\?|#)[^'"]*/, ''); //去除参数
        window.history.pushState({}, 0, url);
        login(Authorization, next);
      } else if (window.location.href.indexOf('access_token') > -1 && window.location.href.indexOf('lcdm') > -1) {
        let dz_url = window.location.href.split('?')[1];
        console.log(dz_url, 'dz');
        let cs_arr = dz_url.split('&');
        let params = {};
        for (let i = 0; i < cs_arr.length; i++) {
          //遍历数组，拿到json对象
          params[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
        }
        if (typeof params.access_token != 'undefined') {
          localDataUser.set({
            token: params.access_token,
          });
          let zwwSxxx = {
            lcdm: params.lcdm,
            lcxl: params.lcxl,
            areaCode: params.areaCode,
          };
          localStorage.setItem('ZWW_SXXX', JSON.stringify(zwwSxxx));
          sxblcheckTokenHandle(params.access_token, next, to);
        }
        next();
        // checkTokenHandle();
      } else if (window.location.href.indexOf('access_token') > -1 && window.location.href.indexOf('fccx') > -1) {
        let dz_url = window.location.href.split('?')[1];
        console.log(dz_url, 'dz');
        let cs_arr = dz_url.split('&');
        let params = {};
        for (let i = 0; i < cs_arr.length; i++) {
          //遍历数组，拿到json对象
          params[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
        }
        if (typeof params.access_token != 'undefined') {
          localDataUser.set({
            token: params.access_token,
          });
          let zwwFccx = {
            fccx: params.fccx,
            areaCode: params.areaCode,
          };
          localStorage.setItem('ZWW_fccx', JSON.stringify(zwwFccx));
          fcxxcheckTokenHandle(params.access_token, next, to);
        }
        next();
      } else {
        next();
      }
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../layout'),
    redirect: '/',
    // 子模块的路由注册
    children: subRoutes,
    // beforeEnter: async (to, from, next) => {
    //   // console.log('beforeEnter');
    //   const userData = localDataUser.get();
    //   if (!userData || !userData.userId) {
    //     store.dispatch('getPermission');
    //     next('/');
    //   }
    //   const allPermission = localDataPermission.get();
    //   if (allPermission.length > 0) {
    //     routerPermission(subRoutes, allPermission);
    //   }
    //   //获取所有区域
    //   await getAreaData().then((res) => {
    //     if (res.success) {
    //       store.dispatch('setArea', res.data);
    //     }
    //   });
    // next();
    // }
  },
  {
    path: '**',
    beforeEnter: async (to, from, next) => {
      next('/');
    },
  },
];

const routeData = new Router({
  //mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
});

routeData.beforeEach(async (to, from, next) => {
  const userData = localDataUser.get();
  const allPermission = localDataPermission.get();
  // console.log(333, allPermission);
  allPermission &&
    allPermission.forEach((item) => {
      if (item === 'IEBDC:SY:DJBL') {
        // console.log(555, item);
      }
    });
  let pathName = ['home', 'user-center', 'xxfw', 'info-search', 'public-announcement', 'guidance', 'policy-law'];
  // 办事指南、政策法规、公示公告未登录也可查看。办事指南,所有配置流程全部显示，未登录不可办理，登陆后，后台设置为不展示的也不可办理
  if (to.path.indexOf('/home/') > -1 && pathName.indexOf(to.name) < 0) {
    if (!userData) {
      if (allPermission && allPermission.length > 0) {
        routerPermission(subRoutes, allPermission);
      } else {
        await store.dispatch('getPermission');
      }
      new Vue()
        .$confirm('请登录后再办理业务', '提示', {
          confirmButtonText: '立马登录',
          cancelButtonText: '暂不登录',
          type: 'warning',
          center: true,
        })
        .then(() => {
          // window.location.href = `${window.CONFIG.UNIFIED_LOGIN}?backUrl=${window.CONFIG.UNIFIED_PAGE}`;
          //处理md5，并且登录
          let sign;
          sign = unifiedService.md5(
            `{"md5Key":"${window.CONFIG.UNIFIED_CLIENT_KEY}","redirectUrl":"${window.CONFIG.UNIFIED_PAGE}"}`
          );
          //跳转外网登录
          window.location.href = `${crypto.decryptByDES(window.CONFIG.UNIFIED_LOGIN)}?clientId=${
            window.CONFIG.UNIFIED_CLIENT_ID
          }&redirectUrl=${crypto.decryptByDES(window.CONFIG.UNIFIED_PAGE)}&sign=${sign}`;
        })
        .catch();
      next({ name: 'home-login-out' });
      // location.reload();
      // } else if (Number(userData.realNameStatus) === 0) {
      //   new Vue()
      //     .$confirm('请进行扫脸实名认证,扫脸实名后才可办理此业务', '提示', {
      //       confirmButtonText: '立马认证',
      //       cancelButtonText: '暂不认证',
      //       type: 'warning',
      //       center: true
      //     })
      //     .then(() => {
      //       Vue.prototype.$slsm();
      //     })
      //     .catch();
    } else {
      next();
    }
  } else {
    next();
  }
});

export default routeData;
